/**
 * Formats a number as a percentage string with two decimal places.
 *
 * @param percentage - The number to format as a percentage.
 * @returns The formatted percentage string.
 */
export function formatPercentage(percentage) {
    return `${percentage.toFixed(2)}%`;
}
